import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import PopoverMenuItem from './components/PopoverMenuItem'
import PopoverMenuLink from './components/PopoverMenuLink'

type PropTypes = {
  buttonContent: React.ReactNode
  children: React.ReactNode
}

const PopoverMenu = ({ buttonContent, children }: PropTypes) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          className="text-[8px] p-1 rounded-sm transition-all"
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => e.stopPropagation()}
        >
          {buttonContent}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute z-50 right-0 mt-2 w-56 origin-top-right rounded-[5px] bg-gray-900 shadow-lg focus:outline-none p-2 flex gap-1 flex-col">
          {children}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

PopoverMenu.Item = PopoverMenuItem
PopoverMenu.Link = PopoverMenuLink

export default PopoverMenu
